import React from 'react';
import PropTypes from 'prop-types';
import Box from '@g4/boneyard/lib/Box';

import { CALENDAR_VIEW, LIST_VIEW } from '../constants';
import { useMedia } from '@g4/boneyard/lib/Media';
import styled from 'styled-components';
import { useTranslations } from '../../../graphql/components/TranslationsProvider';
import { withValue } from '@g4/automation-hooks';
import {
  FLIGHTS_LIST_VIEW_BUTTON,
  FLIGHTS_CALENDAR_VIEW_BUTTON,
} from '../../../../automationHooks.json';

const propTypes = {
  onToggle: PropTypes.func.isRequired,
  leg: PropTypes.string.isRequired,
  currentView: PropTypes.string.isRequired,
};

const ViewToggleDisplay = styled(Box)`
  display: flex;
  flex: auto;
  justify-content: flex-end;
  align-items: flex-end;
  position: ${props => (props.viewWidth ? 'relative' : 'static')};
  width: ${props => (props.viewWidth ? '100vw' : 'auto')};
  right: ${props => (props.viewWidth ? '15px' : '0px')};
`;

const ViewToggleButton = styled.button`
  width: ${props => (props.viewWidth ? '100%' : 'auto')};
  max-width: 100%;
  height: 50px;
  text-transform: none;
  padding: 10px;
  color: ${props =>
    props.isSelected
      ? props.theme.colors.common.light
      : props.theme.colors.common.peacockBlue};
  background: ${props =>
    props.isSelected
      ? props.theme.colors.common.peacockBlue
      : props.theme.colors.common.light};
  border-radius: ${props => (props.viewWidth ? '0px' : '8px')};
  border: ${props =>
    !props.isSelected && props.viewWidth
      ? `2px solid ${props.theme.colors.common.peacockBlue}`
      : 'none'};
  border-right: none;
  border-left: none;
`;

const IconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 100%;
  padding-right: 7px;
  color: inherit;
`;

const TextDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const ButtonContent = props => {
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        alighItems: 'center',
        justifyContent: 'center',
        display: 'flex',
      }}
    >
      <IconDiv
        dangerouslySetInnerHTML={{
          __html: props.icon,
        }}
      />
      <TextDiv>{props.text}</TextDiv>
    </div>
  );
};

ButtonContent.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
};

const SearchResultsViewToggle = props => {
  const handleToggle = e => {
    e.preventDefault();
    props.onToggle(e.currentTarget.value, props.leg);
  };

  const translations = useTranslations();
  const {
    listViewButtonText,
    calendarViewButtonText,
  } = translations.flightsPage;

  const mq = useMedia();

  return (
    <ViewToggleDisplay viewWidth={mq.lt('md')}>
      <ViewToggleButton
        value={LIST_VIEW}
        onClick={handleToggle}
        type={'secondary'}
        background={'dark'}
        data-hook={withValue(FLIGHTS_LIST_VIEW_BUTTON.hook, props.leg)}
        children={
          <ButtonContent
            icon={require('../../../images/ic-menu-currentColor.svg?include')}
            text={listViewButtonText}
          />
        }
        isSelected={LIST_VIEW === props.currentView}
        disabled={LIST_VIEW === props.currentView}
        viewWidth={mq.lt('md')}
      />
      <ViewToggleButton
        value={CALENDAR_VIEW}
        onClick={handleToggle}
        type={'secondary'}
        background={'dark'}
        data-hook={withValue(
          FLIGHTS_CALENDAR_VIEW_BUTTON.hook,
          props.leg
        )}
        children={
          <ButtonContent
            icon={require('../../../images/icon-45-calendar-currentColor.svg?include')}
            text={calendarViewButtonText}
          />
        }
        currentView={props.currentView}
        isSelected={CALENDAR_VIEW === props.currentView}
        disabled={CALENDAR_VIEW === props.currentView}
        viewWidth={mq.lt('md')}
      />
    </ViewToggleDisplay>
  );
};

SearchResultsViewToggle.propTypes = propTypes;
SearchResultsViewToggle.displayName = 'SearchResultsViewToggle';

export default SearchResultsViewToggle;
